import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";
import ProjectsGrid from "@Quest/Projects/Components/ProjectsGrid.vue";
import { SaveViewFinishedProjectsPageCommandV1 } from "@Quest/Strategies/Domain/commands-core";
import StrategiesCommands from '@Quest/Strategies/Domain/commands-vue-component';
import StrategiesQueries from "@Quest/Strategies/Domain/queries-vue-component";
import { FinishedProjectsPageReadModel } from '@Quest/Strategies/Domain/readmodels';
import Vue from "vue";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        CorporateNavigation, ProjectsGrid
    }
})
export default class FinishedProjectsPage extends mixins(StrategiesQueries, StrategiesCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: FinishedProjectsPageReadModel | null = null;

    grid: ProjectsGridViewModel = new ProjectsGridViewModel();

    handleShowGridColumnsEditor()
    {
        this.grid.showGridColumnsEditor();
    }

    handleSaveViewSettings()
    {
        const grid = this.grid.getJson();
        this.invokeSaveViewFinishedProjectsPageCommandV1(this.workspaceId, this.strategyId, grid);
    }

    handleClearGridFilters()
    {
        this.grid.clearFilters();
    }

    handleExportGrid()
    {
        this.grid.exportGrid();
    }

    mounted()
    {
        document.title = "Enterprise Finished | TransparentChoice";
        this.runFinishedProjectsPageQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "FinishedProjectsPageReadModel")
        {
            this.rm = model as FinishedProjectsPageReadModel;

            Vue.nextTick(() =>
            {
                this.grid.renderGrid(this.rm.Grid.IdField, this.rm.Grid.Fields, this.rm.Grid.DefaultFieldIds, this.rm.Grid.Options);
                this.grid.setProjects(this.rm.Projects.map(p => p.Properties));
            })
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (SaveViewFinishedProjectsPageCommandV1.matchType(cmd))
        {
            alert("Saved");
        }
    }
}